<script>
import baseMixin from '@/mixins/baseMixin'
import { CheckboxField } from '@/models/forms/fields/checkboxField'
import InfoLabel from '../general/info-label.vue'

export default {
  name: 'FormSubmissionCheckboxField',
  components: {
    InfoLabel,
  },
  mixins: [baseMixin],
  props: {
    field: {
      type: CheckboxField,
      required: true,
    },
    value: {
      type: [Boolean, null],
      default: null,
    },
  },
  computed: {
    compResponse() {
      if (this.value === null) return ''
      return this.value ? this.$t('general.yes') : this.$t('general.no')
    },
  },
}
</script>

<template>
  <div>
    <InfoLabel :label="field.label">
      <span class="font-weight-medium">{{ compResponse }}</span>
    </InfoLabel>
  </div>
</template>
